import router from "../../router";
import IbonazzService from "@/services/ibonazz-service";


/*** Products */
export function loadTurList({ commit }, payload) {
    IbonazzService.getTurList(payload).then(response => {
        commit("_setTurListArray", response.data);
        console.log("CALL TurList Result");
    })
    .catch(error => {
        console.log(error);
        reject(error);
    });
}

export function loadFilteredTurList({ commit },payload) {
    IbonazzService.getFilteredTurList(payload).then(response => {
        commit("_setTurListArray", response.data);
    })
    .catch(e => {
        console.log(e);
    });
}

export function addTur({ commit, getters }, payload) {
  return new Promise((resolve, reject) => {
  IbonazzService.addTur(payload).then(response => {
        router.push('/turlar');
          return true;
        })
        .catch(error => {
          return false;
        });
      })
}

export function updateTur({ commit, getters }, payload) {
  return new Promise((resolve, reject) => {
  IbonazzService.updateTur(payload).then(response => {
    router.push('/turlar');
          return true;
        })
        .catch(error => {
          console.log(error);
          return false;
        });
      })

}

export function delTur({ commit, getters }, payload) {
  return new Promise((resolve, reject) => {
  IbonazzService.delTur(payload).then(response => {

                   resolve("true");
        })
        .catch(error => {
          console.log(error);
          reject(error)
          //reject(error)
        });
      })

}




